export default {
    config: {
        defaultWidth: 240,
        align: 'left'
    },
    default: {
        label: 'Location'
    },
    sort: 'play.location',
    lang: {
        name: 'Play Location',
        category: ['User', 'Plays'],
        description: 'Where play was labelled as being located.',
        views: ['list', 'sheet'],
        contexts: ['plays']
    },
    filters: ['play.location']
}